
// var input_elements = [
//   {
//     type: "upload",
//     label: "Upload PAN",
//     name: "upload_pan",
//     show: "",
//     is_required: true,
//   },
//   {
//     type: "upload",
//     label: "Upload Aadhar",
//     name: "upload_aadhar",
//     show: "",
//     is_required: true,
//   },
// ];
function generateUpload(item) {
  var input_fields;
  var uid = Math.random().toString(36).slice(2);
  input_fields = {
    type: item?.type,
    label: item?.label,
    name: item?.name + "_" + uid,
    size: item.size ? item?.size : "col-12",
    show: item.show ? item?.show : "true",
    enum: item.enum
      ? item.enum
      : {
          "application/pdf": [],
          "image/jpeg": [],
        },
    maxSize: 10000000.0,
    validators: {
      required: item.is_required ? item.is_required : "false",
      pattern: [],
      min_length: item.min_length ? item.min_length : "",
      max_length: item.max_length ? item.max_length : "",
    },
    error_messages: {
      min_error: item.min_error ? item.min_error : "",
      max_error: item.max_error ? item.max_error : "",
      pattern_error: item.pattern_error ? item.pattern_error : "",
      required_error: item.required_error ? item.required_error : "",
    },
  };
  return input_fields;
}

export let formGenerator = (input_elements) => {
  var form_elements = [];
  input_elements.map((item) => {
    switch (item.type) {
      case "upload": {
        form_elements.push(generateUpload(item));
        break;
      }
    }
  });
  return form_elements;
};
